<template>
  <div class="tile-preview-container">
    <div class="tile-promo-display-selections-div">
      <div v-if="model.device_type === 'web'" class="tile-promo-display-selections-opt">
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'desktopViewTab' }"
          @click="$emit('clickTab', 'desktopViewTab')"
        >
          Desktop
        </button>
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'mobilewebViewTab' }"
          @click="$emit('clickTab', 'mobilewebViewTab')"
        >
          Mobile
        </button>
      </div>
      <div class="tab-selector mr-4">
        <RfLiquidPreview
          v-model:userData="liquidContextStore.previewUserContext"
          :appId="appsStore.app?.id"
        />
        <RfLanguagePreview :model="model" :actions="actions" />
      </div>
    </div>
    <div
      v-if="viewTypeTab === 'desktopViewTab'"
      ref="desktop"
      class="promo-text-wrapper cursor-not-allowed"
      :style="tileStyles"
    >
      <span v-if="closeButtonEnabled" class="rfmodal-close">
        <v-icon :style="{ color: fillColor }">md:close</v-icon>
      </span>
      <div class="promo-text-wrapper-container">
        <div>
          <!-- extra div layer to match brig -->
          <div class="promo-text-title" :style="titleStyle" v-html="parsedRetentionTitle"></div>
          <div class="promo-text-body">
            <RfBodyCountdown :actions="actions" />
            <div
              class="promo-text-message"
              :style="messageStyle"
              v-html="parsedRetentionMessage"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="viewTypeTab === 'mobilewebViewTab'"
      ref="mobile"
      class="retention-tile-mweb-preview cursor-not-allowed"
    >
      <div class="promo-text-wrapper-mobile-preview">
        <div class="promo-text-wrapper-mobile" :style="mobileTileStyles">
          <span v-if="closeButtonEnabled" class="rfmodal-close">
            <v-icon :style="{ color: fillColor }">md:close</v-icon>
          </span>
          <div class="promo-text-wrapper-container">
            <div
              class="promo-text-title"
              :style="titleStyleMobile"
              v-html="parsedMobileTitle"
            ></div>
            <div class="promo-text-body">
              <RfBodyCountdown :actions="actions" />
              <div
                class="promo-text-message"
                :style="messageStyleMobile"
                v-html="parsedMobileMessage"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <component :is="'style'" v-if="previewActions.rf_settings_custom_css">
      {{ actions.rf_settings_custom_css }}
    </component>
  </div>
</template>

<script>
import { useAppsStore } from "@/pinia/appsStore";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfLanguagePreview from "@/components/RfPathCreate/RfRetentionDevices/RfLanguagePreview.vue";
import RfBodyCountdown from "./RfBodyCountdown.vue";
import CompositeImageSaver from "@/utils/CompositeImageSaver";
import RfLiquidPreview from "../RfRetentionDevices/RfLiquidPreview.vue";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionTileText",
  components: { RfLanguagePreview, RfBodyCountdown, RfLiquidPreview },
  mixins: [LanguagePreviewMixin],
  props: ["actions", "viewTypeTab", "model"],
  setup: () => ({
    appsStore: useAppsStore(),
    liquidContextStore: useLiquidContextStore(),
  }),
  computed: {
    parsedRetentionTitle() {
      return this.liquidContextStore.liquidify(this.previewActions?.rf_retention_title);
    },
    parsedRetentionMessage() {
      return this.liquidContextStore.liquidify(this.previewActions?.rf_retention_message);
    },
    parsedMobileTitle() {
      return this.liquidContextStore.liquidify(this.previewActions?.rf_mobile_title);
    },
    parsedMobileMessage() {
      return this.liquidContextStore.liquidify(this.previewActions?.rf_mobile_message);
    },
    tileStyles() {
      return {
        "width": this.previewActions.rf_settings_tile_width,
        "height": this.previewActions.rf_settings_tile_height,
        "background-color": this.previewActions.rf_settings_bg_image_color,
        [this.isClickDisabled ? "pointer-events" : null]: "none",
      };
    },
    mobileTileStyles() {
      return {
        "width": this.previewActions.rf_mobile_width,
        "height": this.previewActions.rf_mobile_height,
        "background-color": this.previewActions.rf_settings_bg_image_color,
        [this.isClickDisabled ? "pointer-events" : null]: "none",
      };
    },
    isClickDisabled() {
      return ["true", true].indexOf(this.previewActions.rf_settings_disable_click) > -1;
    },
    messageStyle() {
      return {
        "font-size": this.previewActions.rf_settings_message_font_size,
        "color": this.fillColor,
      };
    },
    fillColor() {
      return this.previewActions.rf_settings_fill_color;
    },
    titleStyle() {
      return {
        "font-size": this.previewActions.rf_settings_title_font_size,
        "color": this.fillColor,
        "padding-top": this.previewActions.rf_settings_title_padding_top,
      };
    },
    titleStyleMobile() {
      return {
        "font-size": this.previewActions.rf_settings_mobile_title_font_size,
        "color": this.fillColor,
      };
    },
    messageStyleMobile() {
      return {
        "font-size": this.previewActions.rf_settings_mobile_message_font_size,
        "color": this.fillColor,
      };
    },
    closeButtonEnabled() {
      return `${this.previewActions.rf_settings_close_button_enabled}` === "true" && !this.isSticky;
    },
    isSticky() {
      return (
        this.previewActions.rf_settings_tile_interaction === "container" &&
        `${this.previewActions.rf_settings_permanent_display}` === "true"
      );
    },
  },
  methods: {
    async fillModel(model) {
      await CompositeImageSaver.fill(model, this.$refs, this.appsStore.app);
    },
  },
};
</script>
